<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="1100px">
        <el-form size="small" :model="form" :label-width="formLabelWidth" ref="form">

            <div class="common-form">基本信息</div>
            <el-descriptions class="margin-top" title="" :column="3" size="medium" border>
                <el-descriptions-item>
                    <template slot="label">标题</template>
                    {{ detail.title }}
                </el-descriptions-item>

                <el-descriptions-item>
                    <template slot="label">发送时间</template>
                    {{ detail.create_time }}
                </el-descriptions-item>

<!--                <el-descriptions-item>-->
<!--                    <template slot="label">发送对象</template>-->
<!--                    <el-tag v-if="detail.dept_desc" v-for="(item,index) in detail.dept_desc" :key="index" type="success">{{ item }}</el-tag>-->
<!--                </el-descriptions-item>-->

            </el-descriptions>


            <div class="common-form">公告内容</div>
            <el-descriptions class="margin-top" title="" :column="1" size="medium" border >
                <el-descriptions-item>
                    <template slot="label">发送对象</template>
                    <el-tag v-if="detail.dept_desc" v-for="(item,index) in detail.dept_desc" :key="index" type="success">{{ item }}</el-tag>
                </el-descriptions-item>
<!--                <el-descriptions-item>-->
<!--                    <template slot="label">封面</template>-->
<!--                    <el-image style="height: 40px" fit="contain" v-if="detail.file_path" class="ya-img-table" :src="detail.file_path"-->
<!--                              :preview-src-list="[detail.file_path]" title="点击查看大图"/>-->
<!--                </el-descriptions-item>-->
                <el-descriptions-item>
                    <template slot="label">内容</template>
                    <div v-html="detail.content"></div>
                </el-descriptions-item>
            </el-descriptions>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import { activityDetail } from '@/api/education';

    export default {
        components: {},
        data() {
            return {
                title: '详情',
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,

                form: {},
                activity_id: '',
                detail: []
            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.$message({message: '获取详情失败', type: 'error'});
                } else {
                    console.log(row)
                    this.detail = Object.assign({}, row)
                    // this.activity_id = row.activity_id
                    // this.getDetail()
                }
                this.dialogFormVisible = true
            },
            save() {
                this.close()
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                this.dialogFormVisible = false
            },
            // getDetail() {
            //     activityDetail({id: this.activity_id}).then((result) => {
            //         this.detail = Object.assign({}, result.data)
            //         if(this.detail.video_id > 0){
            //             this.detail.video_url = result.data.video.file_path
            //         }
            //     })
            // },

        }
    };
</script>

<style scoped>
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/notice/notice/detail.vue